interface AlarmTriggerMarkerProps {
  /** Pixel x of the trigger moment */
  x: number;
  /** Top and bottom of the vertical line, in pixels */
  y1: number;
  y2: number;
  /** Trigger moment (ms), shown as a clock time next to the bell */
  time: number;
  /** Plot width, so the label flips left near the right edge */
  containerWidth: number;
}

const LINE = 'rgb(194, 31, 31)';
const BELL = 'rgb(220, 38, 38)';
const BELL_FILL = 'rgb(254, 226, 226)';

/**
 * AlarmTriggerMarker - the red "alarm fired here" line with a bell and time.
 *
 * Renders inside an existing <svg>; the caller leaves headroom above `y1`
 * for the bell.
 */
export function AlarmTriggerMarker({
  x,
  y1,
  y2,
  time,
  containerWidth,
}: AlarmTriggerMarkerProps) {
  const label = new Date(time).toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  const renderOnLeft = x > containerWidth - 70;
  const labelX = renderOnLeft
    ? Math.max(6, x - 12)
    : Math.min(containerWidth - 6, x + 12);

  return (
    <g>
      <line x1={x} x2={x} y1={y1} y2={y2} stroke={LINE} strokeWidth={2} />
      <g transform={`translate(${x - 8}, ${y1 - 16})`}>
        <rect
          width={16}
          height={16}
          rx={6}
          ry={6}
          fill={BELL_FILL}
          stroke={BELL}
          strokeWidth={1}
        />
        <path
          d='M5.5 9C5.5 9.5523 5.0523 10 4.5 10C3.9477 10 3.5 9.5523 3.5 9H5.5ZM5 1.03613C6.6961 1.27879 8 2.7368 8 4.5V7.5H9V8.5H0V7.5H1V4.5C1 2.7368 2.3039 1.27879 4 1.03613V0H5V1.03613ZM4.5 2C3.11929 2 2 3.11929 2 4.5V7.5H7V4.5C7 3.11929 5.8807 2 4.5 2Z'
          fill={BELL}
          transform='translate(3.5, 3)'
        />
      </g>
      <text
        x={labelX}
        y={y1 - 4}
        textAnchor={renderOnLeft ? 'end' : 'start'}
        dominantBaseline='middle'
        fill={LINE}
        fontSize='11'
        fontWeight='600'
      >
        {label}
      </text>
    </g>
  );
}
